const styles = theme => ({
  root: {
    marginBottom: '24px'
  },
})

export default styles
